import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "navbar"
}
const _hoisted_2 = { class: "navbar__content" }
const _hoisted_3 = { class: "nav-left" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "customer-logo"
}
const _hoisted_6 = { class: "nav-right" }
const _hoisted_7 = ["href"]

import {computed, reactive, watch} from 'vue';
    import { NavigationStore } from '@/stores/navigation';   
    import { useI18n } from 'vue-i18n';
    import router from '@/router';
    import ConfirmPopup from '@/components/ConfirmPopup.vue';
    import LanguageSelector from '@/components/LanguageSelector.vue';
    import PaidOrderIcon from '@/components/PaidOrderIcon.vue';
    import { AppStore } from '@/stores/app';
    import { CartStore } from '@/stores/cart';
    import { ShopStore } from '@/stores/shop';
    import { AuthStore } from '@/stores/auth';
    import CouponsIcon from "@/components/CouponsIcon.vue";
    import ProfileMenu from "@/components/ProfileMenu.vue";
    import {useRoute} from "vue-router";

    interface State {
        showConfirmPopup: boolean,
        showCancelOrderPopup: boolean
        showProfileMenu: boolean
    }

    /* Reactive */
    
export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationComponent',
  setup(__props) {

    /* imports */
    const { t } = useI18n();
    const navigationStore = NavigationStore();

    const appStore = AppStore();
    const cartStore = CartStore();
    const shopStore = ShopStore();
    const authStore = AuthStore();
    const route = useRoute();
    /* Interface */
    const state = reactive<State>({
        showConfirmPopup: false,
        showCancelOrderPopup: false,
        showProfileMenu: false,
    });

    /* Computed */
    const shouldHandleClearOrder = computed<boolean>(() => {
      const name = navigationStore.state.link?.name;
      if (!name)
          return false;

      const route = router.getRoutes().find(r=>r.name === name);
      if(route && route.meta?.confirmCartReset === true){
        //if the route has confirmCartReset set to true, and we have items in the cart, we should show the confirm popup
        return cartStore.state.items.length > 0 
      }
      
      return false;

    });
    const loginUri = computed<string>(() => {
        return `/login?redirectUri=${encodeURIComponent(router.currentRoute.value.path)}`;
    });
    
    watch(()=>route.name,(to)=>{
      
      console.log('NavigationComponent detected route as ', to);
    });
    

    const shouldHandleCancelOrder = computed<boolean>(() => {
        const name = appStore.state.currentPage;

        if (!name)
            return false;

        return cartStore.state.currentOrderChanged && (name === 'articlePage' || name === 'editOrder' || name === 'suggestedArticlesPage');

    });

    /* Functions */
    const navigate = (): void => {
        if (shouldHandleClearOrder.value) {
            state.showConfirmPopup = true;
        } else if (shouldHandleCancelOrder.value) {
            state.showCancelOrderPopup = true;
        }
        else {
            if (navigationStore.state.link) {
                router.push(navigationStore.state.link);
            } else {
              router.go(-1);    
            }
        }
    }

    const clearOrder = (value: boolean): void => {
        state.showConfirmPopup = false;

        if (value) {
            shopStore.clear();
            cartStore.clear(true);
            if (navigationStore.state.link) {
                router.push(navigationStore.state.link);
            }
        }
    };

    const cancelAddToOrder = (value: boolean): void => {

        state.showCancelOrderPopup = false;

        if (value) {
            
            if (navigationStore.state.link) {
                router.push(navigationStore.state.    link);
            }
        }
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "from-top" }, {
      default: _withCtx(() => [
        (_unref(navigationStore).state.visible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: "navbar__link",
                    onClick: navigate
                  }, [
                    (_unref(appStore).state.isLargeScreen)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                          (_unref(navigationStore).state.link)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_unref(navigationStore).state.link.text), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (!_unref(navigationStore).state.link)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_unref(t)('button.back')), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_unref(navigationStore).state.link)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(LanguageSelector),
                  _createVNode(CouponsIcon),
                  _createVNode(PaidOrderIcon),
                  (_unref(cartStore).state.settings.enableCustomerLogin)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!_unref(authStore).state.isAuthenticated)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              class: "btn-login",
                              href: _unref(loginUri)
                            }, [
                              _createElementVNode("span", null, _toDisplayString(_unref(t)('navBar.login')), 1)
                            ], 8, _hoisted_7))
                          : _createCommentVNode("", true),
                        _createVNode(ProfileMenu)
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(ConfirmPopup, {
      heading: "cancel.order.header",
      text: "cancel.order.description",
      okButton: "cancel.order.confirm",
      cancelButton: "cancel.order.cancel",
      show: state.showConfirmPopup,
      onOnAnswer: clearOrder
    }, null, 8, ["show"]),
    _createVNode(ConfirmPopup, {
      show: state.showCancelOrderPopup,
      onOnAnswer: cancelAddToOrder
    }, null, 8, ["show"])
  ], 64))
}
}

})